import React from 'react';

class Page extends React.Component {
  render() {
    return (
      <div>
        <h1>Help</h1>
        <p>Some info on how to get help... contact details etc</p>
      </div>
    );
  }
}

export default Page;



/** WEBPACK FOOTER **
 ** ./src/components/help/page.js
 **/